var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDriversLicenseFilled = function SvgDriversLicenseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 124,
    viewBox: "0 0 144 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-public/img/icons/documents/drivers_license_filled.svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 21,
    width: 62,
    height: 42,
    rx: 5,
    fill: "#005FF9",
    stroke: "#005FF9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 30,
    width: 21.3165,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 36,
    width: 15.7674,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 42,
    width: 13,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1526 42.72C52.4393 41.6707 53.3636 40.9918 54.2656 41.0071C54.6612 40.9995 56.3981 40.9995 58.2244 41.0004C60.0507 40.9995 61.7876 40.9995 62.1832 41.0071C63.0852 40.9918 64.0095 41.6707 64.2963 42.72L65.0009 45.3027C65.5112 45.3314 65.9175 45.7467 65.9175 46.2556C65.9175 46.5888 65.7425 46.8829 65.4782 47.0538C65.7999 47.3374 66.0001 47.7298 66.0001 48.1681V49.6002C66.0001 49.8237 65.9476 50.0347 65.8553 50.2228C65.7474 50.4347 65.7523 50.6849 65.867 50.893C65.9544 51.0382 66.0001 51.2091 66.0001 51.3905C66.0001 51.9423 65.5744 52.3978 65.0281 52.4579V52.942C65.0281 53.7316 64.375 54.3742 63.5702 54.3742C62.7654 54.3742 62.1123 53.7316 62.1123 52.942V52.508H54.3366V52.942C54.3366 53.7316 53.6834 54.3742 52.8786 54.3742C52.0738 54.3742 51.4207 53.7316 51.4207 52.942V52.4579C50.8744 52.3978 50.4487 51.9423 50.4487 51.3905C50.4487 51.2091 50.4944 51.0391 50.5751 50.8892C50.6878 50.683 50.6917 50.4366 50.5848 50.2266C50.5012 50.0347 50.4487 49.8227 50.4487 49.6002V48.1681C50.4487 47.7374 50.6422 47.3517 50.9473 47.0891C50.6499 46.9259 50.4487 46.6137 50.4487 46.2556C50.4487 45.7286 50.8842 45.3018 51.4197 45.3018L52.1526 42.72ZM53.4004 48.6201C53.9154 48.6201 54.3335 49.0382 54.3335 49.5532C54.3335 50.0683 53.9154 50.4863 53.4004 50.4863C52.8853 50.4863 52.4673 50.0683 52.4673 49.5532C52.4673 49.0382 52.8853 48.6201 53.4004 48.6201ZM63.0454 48.6201C63.5604 48.6201 63.9784 49.0382 63.9784 49.5532C63.9784 50.0683 63.5604 50.4863 63.0454 50.4863C62.5303 50.4863 62.1123 50.0683 62.1123 49.5532C62.1123 49.0382 62.5303 48.6201 63.0454 48.6201ZM62.1125 46.5985H62.6074C62.7912 46.5985 62.9652 46.5154 63.0771 46.3755C63.1899 46.2355 63.2268 46.0526 63.1792 45.8819C62.9652 45.113 62.6307 43.9177 62.4547 43.287C62.3857 43.0388 62.1504 42.8661 61.882 42.8661H58.223H54.5641C54.2957 42.8661 54.0604 43.0388 53.9913 43.287C53.8153 43.9177 53.4808 45.113 53.2669 45.8819C53.2193 46.0526 53.2562 46.2355 53.369 46.3755C53.4808 46.5154 53.6549 46.5985 53.8387 46.5985H54.3336C54.8995 46.5966 61.5466 46.5966 62.1125 46.5985Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg-public/img/icons/documents/drivers_license_filled.svg__filter0_d",
    x: 0,
    y: 0,
    width: 144,
    height: 124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export { SvgDriversLicenseFilled as ReactComponent };